module.exports = __webpack_public_path__ + "static/icons/icon-discount-92633bdedc95d6248c4ab6f13c141e9a.svg";